(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ApplicationFeatureEntityMapDeleteController',ApplicationFeatureEntityMapDeleteController);

    ApplicationFeatureEntityMapDeleteController.$inject = ['$uibModalInstance', 'entity', 'ApplicationFeatureEntityMap'];

    function ApplicationFeatureEntityMapDeleteController($uibModalInstance, entity, ApplicationFeatureEntityMap) {
        var vm = this;

        vm.applicationFeatureEntityMap = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ApplicationFeatureEntityMap.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
